import { Box, Typography, Divider } from '@mui/material';
import { Link } from 'react-admin';
import { SchoolMapItem } from './statistics/types';

const pct = (part: number, total: number): string =>
    total > 0 ? `${Math.round((part / total) * 100)} %` : '-';

const SchoolMapPopup = ({ school }: { school: SchoolMapItem }) => {
    const totalUsers =
        school.teacher_count + school.student_count + school.pupil_count;

    return (
        <Box sx={{ minWidth: 220, maxWidth: 300 }}>
            <Typography variant="subtitle2" gutterBottom>
                <Link to={`/school/${school.guid}`}>{school.name}</Link>
            </Typography>
            <Typography variant="caption" color="textSecondary" display="block">
                {school.visit_city || school.city}
                {school.visit_address && ` — ${school.visit_address}`}
            </Typography>
            <Divider sx={{ my: 1 }} />
            <Typography variant="body2">
                <strong>Käyttäjät</strong> ({totalUsers})
            </Typography>
            <Box
                component="table"
                sx={{
                    width: '100%',
                    fontSize: '0.8rem',
                    mt: 0.5,
                    '& td': { py: 0.25 },
                }}
            >
                <tbody>
                    <tr>
                        <td>Opettajat</td>
                        <td align="right">{school.teacher_count}</td>
                        <td align="right">
                            MPASSid{' '}
                            {pct(
                                school.teacher_mpass_count,
                                school.teacher_count
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td>Opiskelijat</td>
                        <td align="right">{school.student_count}</td>
                        <td align="right">
                            MPASSid{' '}
                            {pct(
                                school.student_mpass_count,
                                school.student_count
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td>Oppilaat</td>
                        <td align="right">{school.pupil_count}</td>
                        <td align="right">
                            MPASSid{' '}
                            {pct(school.pupil_mpass_count, school.pupil_count)}
                        </td>
                    </tr>
                </tbody>
            </Box>
            <Divider sx={{ my: 1 }} />
            <Typography variant="body2">
                <strong>Tilaukset</strong>
            </Typography>
            <Typography variant="caption">
                Aktiiviset: {school.active_subscriptions} | Tulevat:{' '}
                {school.coming_subscriptions}
            </Typography>
        </Box>
    );
};

export default SchoolMapPopup;
